import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Alacaklar from "../pages/alacaklar/page";
import Borclar from "../pages/borclar/page";
import Siparisler from "../pages/siparisler/page";
import Uyarilar from "../pages/uyarilar/page";
import Raporlar from "../pages/raporlar/page";
import MesajSablonlari from "../pages/mesaj-sablonlari/page";
import Musteriler from "../pages/musteriler/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/alacaklar",
    element: <Alacaklar />,
  },
  {
    path: "/borclar",
    element: <Borclar />,
  },
  {
    path: "/siparisler",
    element: <Siparisler />,
  },
  {
    path: "/uyarilar",
    element: <Uyarilar />,
  },
  {
    path: "/raporlar",
    element: <Raporlar />,
  },
  {
    path: "/musteriler",
    element: <Musteriler />,
  },
  {
    path: "/mesaj-sablonlari",
    element: <MesajSablonlari />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
